import { Component, Input, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDateRangePicker } from "@angular/material/datepicker";
import { CalendarRangeHeaderComponent } from "./calendar-range-header/calendar-range-header.component";

@Component({
  selector: "app-range-calendar",
  templateUrl: "./range-calendar.component.html",
  styleUrl: "./range-calendar.component.scss",
  standalone: false,
})
export class RangeCalendarComponent {
  @Input({ required: true }) dateRangeForm: FormGroup<{
    from: FormControl<Date | null>;
    to: FormControl<Date | null>;
  }>;
  @Input() label: string;

  @ViewChild("picker") private picker?: MatDateRangePicker<Date>;

  readonly CalendarRangeHeaderComponent = CalendarRangeHeaderComponent;

  open(): void {
    this.picker?.open();
  }
}
